import React from 'react';
export default class TimelineResumeEmployment extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.companyName){
            title.push(<span data-v-2568b4c2="">{data.companyName}</span>)
        }
        if (data.location){
            title.push(<span data-v-2568b4c2="">{data.location}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span data-v-2568b4c2="" className="comma">, </span>)
            }
        }

        return <div data-v-2568b4c2="" className="section-item" key={index}>
            <div data-v-2568b4c2="" className="section-metas">
                <div data-v-2568b4c2="" className="section-title">
                    <div data-v-2568b4c2="" className="company-title">{titleFinal}</div>
                    <div data-v-2568b4c2="" className="section-title-secondary">{data.jobTitle}</div>
                </div>
                <div data-v-2568b4c2="" className="section-date"><span data-v-2568b4c2="">{data.startDate} -</span><span
                    data-v-2568b4c2="">{data.endDate}</span></div>
            </div>
            <div data-v-2568b4c2="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
        </div>
    }

    render(){
        return  <div data-v-2568b4c2="" className="section">
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}